import { createContext } from 'react';

export type Theme = 'light' | 'dark';

export interface ThemeContextValue {
  setTheme: (theme: Theme) => Promise<void>;
  theme: Theme;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
